import React from 'react';
import { bookingShape } from 'constants/propTypes';
import { intlShape } from 'react-intl';
import { FormattedMessage } from 'react-intl';
import { StyledH2 } from './styles';
import Table from 'components/ui/Table';
import { createBreakdownTableData } from './utils';
import { colours } from 'themes/default';

const PriceBreakdown = ({ booking, intl }) => {
  const { rows, columns } = createBreakdownTableData(booking, intl);

  return (
    <>
      <StyledH2>
        <FormattedMessage id="quoteConfirmation.breakdown.title" />
      </StyledH2>
      <Table
        rows={rows}
        columns={columns}
        headerBackground={colours.Greyscale.CharcoalGrey}
        alternateBackground={colours.Greyscale.SmokeGrey}
      />
    </>
  );
};

PriceBreakdown.propTypes = {
  booking: bookingShape.isRequired,
  intl: intlShape.isRequired
};

export default PriceBreakdown;
